/*! For license information please see mailgun.web.js.LICENSE.txt */
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.mailgun = e() : t.mailgun = e();
}(this, function () {
  return (() => {
    var t = {
        475: function (t, e, r) {
          "use strict";

          var n = this && this.__assign || function () {
              return n = Object.assign || function (t) {
                for (var e, r = 1, n = arguments.length; r < n; r++) for (var s in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
                return t;
              }, n.apply(this, arguments);
            },
            s = this && this.__importDefault || function (t) {
              return t && t.__esModule ? t : {
                default: t
              };
            };
          Object.defineProperty(e, "__esModule", {
            value: !0
          });
          var o = s(r(438)),
            i = s(r(373)),
            a = s(r(22)),
            u = s(r(747)),
            h = s(r(778)),
            p = s(r(750)),
            c = s(r(197)),
            f = s(r(277)),
            l = s(r(721)),
            d = s(r(345)),
            y = s(r(602)),
            m = s(r(126)),
            v = s(r(135)),
            b = s(r(60)),
            g = s(r(734)),
            _ = s(r(955)),
            w = s(r(75)),
            q = function (t, e) {
              var r = n({}, t);
              if (r.url || (r.url = "https://api.mailgun.net"), !r.username) throw new Error('Parameter "username" is required');
              if (!r.key) throw new Error('Parameter "key" is required');
              this.request = new o.default(r, e);
              var s = new v.default(this.request),
                q = new b.default(this.request),
                R = new _.default(this.request),
                D = new w.default(this.request),
                j = new g.default(this.request);
              this.domains = new i.default(this.request, q, R, D), this.webhooks = new p.default(this.request), this.events = new a.default(this.request), this.stats = new u.default(this.request), this.suppressions = new h.default(this.request), this.messages = new c.default(this.request), this.routes = new f.default(this.request), this.ips = new d.default(this.request), this.ip_pools = new y.default(this.request), this.lists = new m.default(this.request, s), this.validate = new l.default(this.request, j);
            };
          e.default = q;
        },
        373: function (t, e, r) {
          "use strict";

          var n = this && this.__assign || function () {
              return n = Object.assign || function (t) {
                for (var e, r = 1, n = arguments.length; r < n; r++) for (var s in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
                return t;
              }, n.apply(this, arguments);
            },
            s = this && this.__importDefault || function (t) {
              return t && t.__esModule ? t : {
                default: t
              };
            };
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.Domain = void 0;
          var o = s(r(78)),
            i = s(r(142)),
            a = function (t, e, r) {
              this.name = t.name, this.require_tls = t.require_tls, this.skip_verification = t.skip_verification, this.state = t.state, this.wildcard = t.wildcard, this.spam_action = t.spam_action, this.created_at = t.created_at, this.smtp_password = t.smtp_password, this.smtp_login = t.smtp_login, this.type = t.type, this.receiving_dns_records = e || null, this.sending_dns_records = r || null;
            };
          e.Domain = a;
          var u = function () {
            function t(t, e, r, n) {
              this.request = t, this.domainCredentials = e, this.domainTemplates = r, this.domainTags = n;
            }
            return t.prototype._parseMessage = function (t) {
              return t.body;
            }, t.prototype._parseDomainList = function (t) {
              return t.body.items.map(function (t) {
                return new a(t);
              });
            }, t.prototype._parseDomain = function (t) {
              return new a(t.body.domain, t.body.receiving_dns_records, t.body.sending_dns_records);
            }, t.prototype._parseTrackingSettings = function (t) {
              return t.body.tracking;
            }, t.prototype._parseTrackingUpdate = function (t) {
              return t.body;
            }, t.prototype.list = function (t) {
              var e = this;
              return this.request.get("/v3/domains", t).then(function (t) {
                return e._parseDomainList(t);
              });
            }, t.prototype.get = function (t) {
              var e = this;
              return this.request.get("/v3/domains/" + t).then(function (t) {
                return e._parseDomain(t);
              });
            }, t.prototype.create = function (t) {
              var e = this,
                r = n({}, t);
              return "force_dkim_authority" in r && "boolean" == typeof r.force_dkim_authority && (r.force_dkim_authority = "true" === r.toString() ? "true" : "false"), this.request.postWithFD("/v3/domains", r).then(function (t) {
                return e._parseDomain(t);
              });
            }, t.prototype.destroy = function (t) {
              var e = this;
              return this.request.delete("/v3/domains/" + t).then(function (t) {
                return e._parseMessage(t);
              });
            }, t.prototype.getConnection = function (t) {
              return this.request.get("/v3/domains/" + t + "/connection").then(function (t) {
                return t;
              }).then(function (t) {
                return t.body.connection;
              });
            }, t.prototype.updateConnection = function (t, e) {
              return this.request.put("/v3/domains/" + t + "/connection", e).then(function (t) {
                return t;
              }).then(function (t) {
                return t.body;
              });
            }, t.prototype.getTracking = function (t) {
              return this.request.get((0, o.default)("/v3/domains", t, "tracking")).then(this._parseTrackingSettings);
            }, t.prototype.updateTracking = function (t, e, r) {
              var n = this;
              if ("boolean" == typeof (null == r ? void 0 : r.active)) throw new i.default({
                status: 400,
                statusText: "",
                body: {
                  message: 'Property "active" must contain string value.'
                }
              });
              return this.request.putWithFD((0, o.default)("/v3/domains", t, "tracking", e), r).then(function (t) {
                return n._parseTrackingUpdate(t);
              });
            }, t.prototype.getIps = function (t) {
              return this.request.get((0, o.default)("/v3/domains", t, "ips")).then(function (t) {
                var e;
                return null === (e = null == t ? void 0 : t.body) || void 0 === e ? void 0 : e.items;
              });
            }, t.prototype.assignIp = function (t, e) {
              return this.request.postWithFD((0, o.default)("/v3/domains", t, "ips"), {
                ip: e
              });
            }, t.prototype.deleteIp = function (t, e) {
              return this.request.delete((0, o.default)("/v3/domains", t, "ips", e));
            }, t.prototype.linkIpPool = function (t, e) {
              return this.request.postWithFD((0, o.default)("/v3/domains", t, "ips"), {
                pool_id: e
              });
            }, t.prototype.unlinkIpPoll = function (t, e) {
              var r = "";
              if (e.pool_id && e.ip) throw new i.default({
                status: 400,
                statusText: "",
                body: {
                  message: "Please specify either pool_id or ip (not both)"
                }
              });
              return e.pool_id ? r = "?pool_id=" + e.pool_id : e.ip && (r = "?ip=" + e.ip), this.request.delete((0, o.default)("/v3/domains", t, "ips", "ip_pool", r));
            }, t.prototype.updateDKIMAuthority = function (t, e) {
              return this.request.put("/v3/domains/" + t + "/dkim_authority", {}, {
                query: "self=" + e.self
              }).then(function (t) {
                return t;
              }).then(function (t) {
                return t.body;
              });
            }, t.prototype.updateDKIMSelector = function (t, e) {
              return this.request.put("/v3/domains/" + t + "/dkim_selector", {}, {
                query: "dkim_selector=" + e.dkimSelector
              }).then(function (t) {
                return t;
              });
            }, t.prototype.updateWebPrefix = function (t, e) {
              return this.request.put("/v3/domains/" + t + "/web_prefix", {}, {
                query: "web_prefix=" + e.webPrefix
              }).then(function (t) {
                return t;
              });
            }, t;
          }();
          e.default = u;
        },
        60: function (t, e, r) {
          "use strict";

          var n = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
          Object.defineProperty(e, "__esModule", {
            value: !0
          });
          var s = n(r(78)),
            o = function () {
              function t(t) {
                this.request = t, this.baseRoute = "/v3/domains/";
              }
              return t.prototype._parseDomainCredentialsList = function (t) {
                return {
                  items: t.body.items,
                  totalCount: t.body.total_count
                };
              }, t.prototype._parseMessageResponse = function (t) {
                return {
                  status: t.status,
                  message: t.body.message
                };
              }, t.prototype._parseDeletedResponse = function (t) {
                return {
                  status: t.status,
                  message: t.body.message,
                  spec: t.body.spec
                };
              }, t.prototype.list = function (t, e) {
                var r = this;
                return this.request.get((0, s.default)(this.baseRoute, t, "/credentials"), e).then(function (t) {
                  return r._parseDomainCredentialsList(t);
                });
              }, t.prototype.create = function (t, e) {
                var r = this;
                return this.request.postWithFD("" + this.baseRoute + t + "/credentials", e).then(function (t) {
                  return r._parseMessageResponse(t);
                });
              }, t.prototype.update = function (t, e, r) {
                var n = this;
                return this.request.putWithFD("" + this.baseRoute + t + "/credentials/" + e, r).then(function (t) {
                  return n._parseMessageResponse(t);
                });
              }, t.prototype.destroy = function (t, e) {
                var r = this;
                return this.request.delete("" + this.baseRoute + t + "/credentials/" + e).then(function (t) {
                  return r._parseDeletedResponse(t);
                });
              }, t;
            }();
          e.default = o;
        },
        75: function (t, e, r) {
          "use strict";

          var n = this && this.__assign || function () {
              return n = Object.assign || function (t) {
                for (var e, r = 1, n = arguments.length; r < n; r++) for (var s in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
                return t;
              }, n.apply(this, arguments);
            },
            s = this && this.__importDefault || function (t) {
              return t && t.__esModule ? t : {
                default: t
              };
            };
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.DomainTagStatistic = e.DomainTag = void 0;
          var o = s(r(78)),
            i = function (t) {
              this.tag = t.tag, this.description = t.description, this["first-seen"] = new Date(t["first-seen"]), this["last-seen"] = new Date(t["last-seen"]);
            };
          e.DomainTag = i;
          var a = function (t) {
            this.tag = t.body.tag, this.description = t.body.description, this.start = new Date(t.body.start), this.end = new Date(t.body.end), this.resolution = t.body.resolution, this.stats = t.body.stats.map(function (t) {
              return n(n({}, t), {
                time: new Date(t.time)
              });
            });
          };
          e.DomainTagStatistic = a;
          var u = function () {
            function t(t) {
              this.request = t, this.baseRoute = "/v3/";
            }
            return t.prototype._parsePageLinks = function (t) {
              return Object.entries(t.body.paging).reduce(function (t, e) {
                var r = e[0],
                  n = e[1];
                return t[r] = {
                  id: r,
                  url: n
                }, t;
              }, {});
            }, t.prototype._parseDomainTagsList = function (t) {
              return {
                items: t.body.items.map(function (t) {
                  return new i(t);
                }),
                pages: this._parsePageLinks(t)
              };
            }, t.prototype._parseTagStatistic = function (t) {
              return new a(t);
            }, t.prototype.list = function (t, e) {
              var r = this;
              return this.request.get((0, o.default)(this.baseRoute, t, "/tags"), e).then(function (t) {
                return r._parseDomainTagsList(t);
              });
            }, t.prototype.get = function (t, e) {
              return this.request.get((0, o.default)(this.baseRoute, t, "/tags", e)).then(function (t) {
                return new i(t.body);
              });
            }, t.prototype.update = function (t, e, r) {
              return this.request.put((0, o.default)(this.baseRoute, t, "/tags", e), r).then(function (t) {
                return t.body;
              });
            }, t.prototype.destroy = function (t, e) {
              return this.request.delete("" + this.baseRoute + t + "/tags/" + e).then(function (t) {
                return {
                  message: t.body.message,
                  status: t.status
                };
              });
            }, t.prototype.statistic = function (t, e, r) {
              var n = this;
              return this.request.get((0, o.default)(this.baseRoute, t, "/tags", e, "stats"), r).then(function (t) {
                return n._parseTagStatistic(t);
              });
            }, t.prototype.countries = function (t, e) {
              return this.request.get((0, o.default)(this.baseRoute, t, "/tags", e, "stats/aggregates/countries")).then(function (t) {
                return t.body;
              });
            }, t.prototype.providers = function (t, e) {
              return this.request.get((0, o.default)(this.baseRoute, t, "/tags", e, "stats/aggregates/providers")).then(function (t) {
                return t.body;
              });
            }, t.prototype.devices = function (t, e) {
              return this.request.get((0, o.default)(this.baseRoute, t, "/tags", e, "stats/aggregates/devices")).then(function (t) {
                return t.body;
              });
            }, t;
          }();
          e.default = u;
        },
        955: function (t, e, r) {
          "use strict";

          var n = this && this.__assign || function () {
              return n = Object.assign || function (t) {
                for (var e, r = 1, n = arguments.length; r < n; r++) for (var s in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
                return t;
              }, n.apply(this, arguments);
            },
            s = this && this.__importDefault || function (t) {
              return t && t.__esModule ? t : {
                default: t
              };
            };
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.DomainTemplateItem = void 0;
          var o = s(r(78)),
            i = function (t) {
              this.name = t.name, this.description = t.description, this.createdAt = t.createdAt ? new Date(t.createdAt) : "", this.createdBy = t.createdBy, this.id = t.id, t.version && (this.version = t.version, t.version.createdAt && (this.version.createdAt = new Date(t.version.createdAt))), t.versions && t.versions.length && (this.versions = t.versions.map(function (t) {
                var e = n({}, t);
                return e.createdAt = new Date(t.createdAt), e;
              }));
            };
          e.DomainTemplateItem = i;
          var a = function () {
            function t(t) {
              this.request = t, this.baseRoute = "/v3/";
            }
            return t.prototype.parseCreationResponse = function (t) {
              return new i(t.body.template);
            }, t.prototype.parseCreationVersionResponse = function (t) {
              var e = {};
              return e.status = t.status, e.message = t.body.message, t.body && t.body.template && (e.template = new i(t.body.template)), e;
            }, t.prototype.parseMutationResponse = function (t) {
              var e = {};
              return e.status = t.status, e.message = t.body.message, t.body && t.body.template && (e.templateName = t.body.template.name), e;
            }, t.prototype.parseNotificationResponse = function (t) {
              var e = {};
              return e.status = t.status, e.message = t.body.message, e;
            }, t.prototype.parseMutateTemplateVersionResponse = function (t) {
              var e = {};
              return e.status = t.status, e.message = t.body.message, t.body.template && (e.templateName = t.body.template.name, e.templateVersion = {
                tag: t.body.template.version.tag
              }), e;
            }, t.prototype.parseList = function (t) {
              var e = {};
              return e.items = t.body.items.map(function (t) {
                return new i(t);
              }), e.pages = t.body.paging, e;
            }, t.prototype.parseListTemplateVersions = function (t) {
              var e = {};
              return e.template = new i(t.body.template), e.pages = t.body.paging, e;
            }, t.prototype.list = function (t, e) {
              var r = this;
              return this.request.get((0, o.default)(this.baseRoute, t, "/templates"), e).then(function (t) {
                return r.parseList(t);
              });
            }, t.prototype.get = function (t, e, r) {
              return this.request.get((0, o.default)(this.baseRoute, t, "/templates/", e), r).then(function (t) {
                return new i(t.body.template);
              });
            }, t.prototype.create = function (t, e) {
              var r = this;
              return this.request.postWithFD((0, o.default)(this.baseRoute, t, "/templates"), e).then(function (t) {
                return r.parseCreationResponse(t);
              });
            }, t.prototype.update = function (t, e, r) {
              var n = this;
              return this.request.putWithFD((0, o.default)(this.baseRoute, t, "/templates/", e), r).then(function (t) {
                return n.parseMutationResponse(t);
              });
            }, t.prototype.destroy = function (t, e) {
              var r = this;
              return this.request.delete((0, o.default)(this.baseRoute, t, "/templates/", e)).then(function (t) {
                return r.parseMutationResponse(t);
              });
            }, t.prototype.destroyAll = function (t) {
              var e = this;
              return this.request.delete((0, o.default)(this.baseRoute, t, "/templates")).then(function (t) {
                return e.parseNotificationResponse(t);
              });
            }, t.prototype.createVersion = function (t, e, r) {
              var n = this;
              return this.request.postWithFD((0, o.default)(this.baseRoute, t, "/templates/", e, "/versions"), r).then(function (t) {
                return n.parseCreationVersionResponse(t);
              });
            }, t.prototype.getVersion = function (t, e, r) {
              return this.request.get((0, o.default)(this.baseRoute, t, "/templates/", e, "/versions/", r)).then(function (t) {
                return new i(t.body.template);
              });
            }, t.prototype.updateVersion = function (t, e, r, n) {
              var s = this;
              return this.request.putWithFD((0, o.default)(this.baseRoute, t, "/templates/", e, "/versions/", r), n).then(function (t) {
                return s.parseMutateTemplateVersionResponse(t);
              });
            }, t.prototype.destroyVersion = function (t, e, r) {
              var n = this;
              return this.request.delete((0, o.default)(this.baseRoute, t, "/templates/", e, "/versions/", r)).then(function (t) {
                return n.parseMutateTemplateVersionResponse(t);
              });
            }, t.prototype.listVersions = function (t, e, r) {
              var n = this;
              return this.request.get((0, o.default)(this.baseRoute, t, "/templates", e, "/versions"), r).then(function (t) {
                return n.parseListTemplateVersions(t);
              });
            }, t;
          }();
          e.default = a;
        },
        142: function (t, e) {
          "use strict";

          var r,
            n = this && this.__extends || (r = function (t, e) {
              return r = Object.setPrototypeOf || {
                __proto__: []
              } instanceof Array && function (t, e) {
                t.__proto__ = e;
              } || function (t, e) {
                for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
              }, r(t, e);
            }, function (t, e) {
              if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
              function n() {
                this.constructor = t;
              }
              r(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
            });
          Object.defineProperty(e, "__esModule", {
            value: !0
          });
          var s = function (t) {
            function e(e) {
              var r = e.status,
                n = e.statusText,
                s = e.message,
                o = e.body,
                i = void 0 === o ? {} : o,
                a = this,
                u = i.message,
                h = i.error;
              return (a = t.call(this) || this).stack = "", a.status = r, a.message = s || h || n, a.details = u, a;
            }
            return n(e, t), e;
          }(Error);
          e.default = s;
        },
        22: function (t, e, r) {
          "use strict";

          var n = this && this.__assign || function () {
              return n = Object.assign || function (t) {
                for (var e, r = 1, n = arguments.length; r < n; r++) for (var s in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
                return t;
              }, n.apply(this, arguments);
            },
            s = this && this.__importDefault || function (t) {
              return t && t.__esModule ? t : {
                default: t
              };
            };
          Object.defineProperty(e, "__esModule", {
            value: !0
          });
          var o = s(r(78)),
            i = function () {
              function t(t) {
                this.request = t;
              }
              return t.prototype._parsePageNumber = function (t) {
                return t.split("/").pop() || "";
              }, t.prototype._parsePage = function (t, e) {
                return {
                  id: t,
                  number: this._parsePageNumber(e),
                  url: e
                };
              }, t.prototype._parsePageLinks = function (t) {
                var e = this;
                return Object.entries(t.body.paging).reduce(function (t, r) {
                  var n = r[0],
                    s = r[1];
                  return t[n] = e._parsePage(n, s), t;
                }, {});
              }, t.prototype._parseEventList = function (t) {
                return {
                  items: t.body.items,
                  pages: this._parsePageLinks(t)
                };
              }, t.prototype.get = function (t, e) {
                var r,
                  s = this,
                  i = n({}, e);
                return i && i.page ? (r = (0, o.default)("/v3", t, "events", i.page), delete i.page) : r = (0, o.default)("/v3", t, "events"), this.request.get(r, i).then(function (t) {
                  return s._parseEventList(t);
                });
              }, t;
            }();
          e.default = i;
        },
        175: function (t, e, r) {
          "use strict";

          var n = (this && this.__importDefault || function (t) {
              return t && t.__esModule ? t : {
                default: t
              };
            })(r(475)),
            s = function () {
              function t(t) {
                this.formData = t;
              }
              return t.prototype.client = function (t) {
                return new n.default(t, this.formData);
              }, t;
            }();
          t.exports = s;
        },
        602: (t, e) => {
          "use strict";

          Object.defineProperty(e, "__esModule", {
            value: !0
          });
          var r = function () {
            function t(t) {
              this.request = t;
            }
            return t.prototype.list = function (t) {
              var e = this;
              return this.request.get("/v1/ip_pools", t).then(function (t) {
                return e.parseIpPoolsResponse(t);
              });
            }, t.prototype.create = function (t) {
              return this.request.postWithFD("/v1/ip_pools", t).then(function (t) {
                return null == t ? void 0 : t.body;
              });
            }, t.prototype.update = function (t, e) {
              return this.request.patchWithFD("/v1/ip_pools/" + t, e).then(function (t) {
                return null == t ? void 0 : t.body;
              });
            }, t.prototype.delete = function (t, e) {
              return this.request.delete("/v1/ip_pools/" + t, e).then(function (t) {
                return null == t ? void 0 : t.body;
              });
            }, t.prototype.parseIpPoolsResponse = function (t) {
              return t.body.ip_pools;
            }, t;
          }();
          e.default = r;
        },
        345: (t, e) => {
          "use strict";

          Object.defineProperty(e, "__esModule", {
            value: !0
          });
          var r = function () {
            function t(t) {
              this.request = t;
            }
            return t.prototype.list = function (t) {
              var e = this;
              return this.request.get("/v3/ips", t).then(function (t) {
                return e.parseIpsResponse(t);
              });
            }, t.prototype.get = function (t) {
              var e = this;
              return this.request.get("/v3/ips/" + t).then(function (t) {
                return e.parseIpsResponse(t);
              });
            }, t.prototype.parseIpsResponse = function (t) {
              return t.body;
            }, t;
          }();
          e.default = r;
        },
        126: (t, e) => {
          "use strict";

          Object.defineProperty(e, "__esModule", {
            value: !0
          });
          var r = function () {
            function t(t, e) {
              this.request = t, this.baseRoute = "/v3/lists", this.members = e;
            }
            return t.prototype.list = function (t) {
              return this.request.get(this.baseRoute + "/pages", t).then(function (t) {
                return t.body.items;
              });
            }, t.prototype.get = function (t) {
              return this.request.get(this.baseRoute + "/" + t).then(function (t) {
                return t.body.list;
              });
            }, t.prototype.create = function (t) {
              return this.request.postWithFD(this.baseRoute, t).then(function (t) {
                return t.body.list;
              });
            }, t.prototype.update = function (t, e) {
              return this.request.putWithFD(this.baseRoute + "/" + t, e).then(function (t) {
                return t.body.list;
              });
            }, t.prototype.destroy = function (t) {
              return this.request.delete(this.baseRoute + "/" + t).then(function (t) {
                return t.body;
              });
            }, t;
          }();
          e.default = r;
        },
        135: function (t, e) {
          "use strict";

          var r = this && this.__assign || function () {
            return r = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var s in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
              return t;
            }, r.apply(this, arguments);
          };
          Object.defineProperty(e, "__esModule", {
            value: !0
          });
          var n = function () {
            function t(t) {
              this.request = t, this.baseRoute = "/v3/lists";
            }
            return t.prototype.checkAndUpdateData = function (t) {
              var e = r({}, t);
              return "object" == typeof t.vars && (e.vars = JSON.stringify(e.vars)), "boolean" == typeof t.subscribed && (e.subscribed = t.subscribed ? "yes" : "no"), e;
            }, t.prototype.listMembers = function (t, e) {
              return this.request.get(this.baseRoute + "/" + t + "/members/pages", e).then(function (t) {
                return t.body.items;
              });
            }, t.prototype.getMember = function (t, e) {
              return this.request.get(this.baseRoute + "/" + t + "/members/" + e).then(function (t) {
                return t.body.member;
              });
            }, t.prototype.createMember = function (t, e) {
              var r = this.checkAndUpdateData(e);
              return this.request.postWithFD(this.baseRoute + "/" + t + "/members", r).then(function (t) {
                return t.body.member;
              });
            }, t.prototype.createMembers = function (t, e) {
              var r = {
                members: Array.isArray(e.members) ? JSON.stringify(e.members) : e.members,
                upsert: e.upsert
              };
              return this.request.postWithFD(this.baseRoute + "/" + t + "/members.json", r).then(function (t) {
                return t.body;
              });
            }, t.prototype.updateMember = function (t, e, r) {
              var n = this.checkAndUpdateData(r);
              return this.request.putWithFD(this.baseRoute + "/" + t + "/members/" + e, n).then(function (t) {
                return t.body.member;
              });
            }, t.prototype.destroyMember = function (t, e) {
              return this.request.delete(this.baseRoute + "/" + t + "/members/" + e).then(function (t) {
                return t.body;
              });
            }, t;
          }();
          e.default = n;
        },
        197: (t, e) => {
          "use strict";

          Object.defineProperty(e, "__esModule", {
            value: !0
          });
          var r = function () {
            function t(t) {
              this.request = t;
            }
            return t.prototype._parseResponse = function (t) {
              return t.body ? t.body : t;
            }, t.prototype.create = function (t, e) {
              return e.message ? this.request.postWithFD("/v3/" + t + "/messages.mime", e).then(this._parseResponse) : this.request.postWithFD("/v3/" + t + "/messages", e).then(this._parseResponse);
            }, t;
          }();
          e.default = r;
        },
        734: (t, e) => {
          "use strict";

          Object.defineProperty(e, "__esModule", {
            value: !0
          });
          var r = function () {
            function t(t) {
              this.request = t;
            }
            return t.prototype.list = function () {
              return this.request.get("/v4/address/validate/bulk").then(function (t) {
                return t.body;
              });
            }, t.prototype.get = function (t) {
              return this.request.get("/v4/address/validate/bulk/" + t).then(function (t) {
                return t.body;
              });
            }, t.prototype.create = function (t, e) {
              return this.request.postWithFD("/v4/address/validate/bulk/" + t, e).then(function (t) {
                return t.body;
              });
            }, t.prototype.destroy = function (t) {
              return this.request.delete("/v4/address/validate/bulk/" + t).then(function (t) {
                return t;
              });
            }, t;
          }();
          e.default = r;
        },
        438: function (t, e, r) {
          "use strict";

          var n = this && this.__assign || function () {
              return n = Object.assign || function (t) {
                for (var e, r = 1, n = arguments.length; r < n; r++) for (var s in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
                return t;
              }, n.apply(this, arguments);
            },
            s = this && this.__awaiter || function (t, e, r, n) {
              return new (r || (r = Promise))(function (s, o) {
                function i(t) {
                  try {
                    u(n.next(t));
                  } catch (t) {
                    o(t);
                  }
                }
                function a(t) {
                  try {
                    u(n.throw(t));
                  } catch (t) {
                    o(t);
                  }
                }
                function u(t) {
                  var e;
                  t.done ? s(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
                    t(e);
                  })).then(i, a);
                }
                u((n = n.apply(t, e || [])).next());
              });
            },
            o = this && this.__generator || function (t, e) {
              var r,
                n,
                s,
                o,
                i = {
                  label: 0,
                  sent: function () {
                    if (1 & s[0]) throw s[1];
                    return s[1];
                  },
                  trys: [],
                  ops: []
                };
              return o = {
                next: a(0),
                throw: a(1),
                return: a(2)
              }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
                return this;
              }), o;
              function a(o) {
                return function (a) {
                  return function (o) {
                    if (r) throw new TypeError("Generator is already executing.");
                    for (; i;) try {
                      if (r = 1, n && (s = 2 & o[0] ? n.return : o[0] ? n.throw || ((s = n.return) && s.call(n), 0) : n.next) && !(s = s.call(n, o[1])).done) return s;
                      switch (n = 0, s && (o = [2 & o[0], s.value]), o[0]) {
                        case 0:
                        case 1:
                          s = o;
                          break;
                        case 4:
                          return i.label++, {
                            value: o[1],
                            done: !1
                          };
                        case 5:
                          i.label++, n = o[1], o = [0];
                          continue;
                        case 7:
                          o = i.ops.pop(), i.trys.pop();
                          continue;
                        default:
                          if (!(s = i.trys, (s = s.length > 0 && s[s.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                            i = 0;
                            continue;
                          }
                          if (3 === o[0] && (!s || o[1] > s[0] && o[1] < s[3])) {
                            i.label = o[1];
                            break;
                          }
                          if (6 === o[0] && i.label < s[1]) {
                            i.label = s[1], s = o;
                            break;
                          }
                          if (s && i.label < s[2]) {
                            i.label = s[2], i.ops.push(o);
                            break;
                          }
                          s[2] && i.ops.pop(), i.trys.pop();
                          continue;
                      }
                      o = e.call(t, i);
                    } catch (t) {
                      o = [6, t], n = 0;
                    } finally {
                      r = s = 0;
                    }
                    if (5 & o[0]) throw o[1];
                    return {
                      value: o[0] ? o[1] : void 0,
                      done: !0
                    };
                  }([o, a]);
                };
              }
            },
            i = this && this.__importDefault || function (t) {
              return t && t.__esModule ? t : {
                default: t
              };
            };
          Object.defineProperty(e, "__esModule", {
            value: !0
          });
          var a = i(r(501)),
            u = i(r(78)),
            h = i(r(899)),
            p = i(r(142)),
            c = function (t) {
              return "object" == typeof t && "function" == typeof t.pipe;
            };
          function f(t) {
            return void 0 !== t.getHeaders;
          }
          var l = function () {
            function t(t, e) {
              this.username = t.username, this.key = t.key, this.url = t.url, this.timeout = t.timeout, this.headers = t.headers || {}, this.FormDataConstructor = e;
            }
            return t.prototype.request = function (t, e, r) {
              return s(this, void 0, void 0, function () {
                var s, i, f, l, d, y, m, v;
                return o(this, function (o) {
                  switch (o.label) {
                    case 0:
                      return s = n({}, r), i = a.default.encode(this.username + ":" + this.key), f = n(n({
                        Authorization: "Basic " + i
                      }, this.headers), null == s ? void 0 : s.headers), null == s || delete s.headers, f["Content-Type"] || delete f["Content-Type"], l = n({}, s), (null == s ? void 0 : s.query) && Object.getOwnPropertyNames(null == s ? void 0 : s.query).length > 0 && (l.searchParams = s.query, delete l.query), [4, (0, h.default)((0, u.default)(this.url, e), n({
                        method: t.toLocaleUpperCase(),
                        headers: f,
                        throwHttpErrors: !1,
                        timeout: this.timeout
                      }, l))];
                    case 1:
                      return (null == (d = o.sent()) ? void 0 : d.ok) ? [3, 6] : (null == d ? void 0 : d.body) && c(d.body) ? [4, (b = d.body, g = [], new Promise(function (t, e) {
                        b.on("data", function (t) {
                          return g.push(t);
                        }), b.on("error", e), b.on("end", function () {
                          return t(Buffer.concat(g).toString("utf8"));
                        });
                      }))] : [3, 3];
                    case 2:
                      return m = o.sent(), [3, 5];
                    case 3:
                      return [4, null == d ? void 0 : d.json()];
                    case 4:
                      m = o.sent(), o.label = 5;
                    case 5:
                      throw y = m, new p.default({
                        status: null == d ? void 0 : d.status,
                        statusText: null == d ? void 0 : d.statusText,
                        body: {
                          message: y
                        }
                      });
                    case 6:
                      return v = {}, [4, null == d ? void 0 : d.json()];
                    case 7:
                      return v.body = o.sent(), v.status = null == d ? void 0 : d.status, [2, v];
                  }
                  var b, g;
                });
              });
            }, t.prototype.query = function (t, e, r, s) {
              return this.request(t, e, n({
                query: r
              }, s));
            }, t.prototype.command = function (t, e, r, s) {
              return this.request(t, e, n({
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded"
                },
                body: r
              }, s));
            }, t.prototype.get = function (t, e, r) {
              return this.query("get", t, e, r);
            }, t.prototype.head = function (t, e, r) {
              return this.query("head", t, e, r);
            }, t.prototype.options = function (t, e, r) {
              return this.query("options", t, e, r);
            }, t.prototype.post = function (t, e, r) {
              return this.command("post", t, e, r);
            }, t.prototype.postWithFD = function (t, e) {
              if (!e) throw new Error("Please provide data object");
              var r = this.createFormData(e);
              return this.command("post", t, r, {
                headers: {
                  "Content-Type": null
                }
              });
            }, t.prototype.putWithFD = function (t, e) {
              if (!e) throw new Error("Please provide data object");
              var r = this.createFormData(e);
              return this.command("put", t, r, {
                headers: {
                  "Content-Type": null
                }
              });
            }, t.prototype.patchWithFD = function (t, e) {
              if (!e) throw new Error("Please provide data object");
              var r = this.createFormData(e);
              return this.command("patch", t, r, {
                headers: {
                  "Content-Type": null
                }
              });
            }, t.prototype.createFormData = function (t) {
              var e = this;
              return Object.keys(t).filter(function (e) {
                return t[e];
              }).reduce(function (r, n) {
                return ["attachment", "inline", "file"].includes(n) ? (e.addFilesToFD(n, t[n], r), r) : "message" === n ? (e.addMimeDataToFD(n, t[n], r), r) : (e.addCommonPropertyToFD(n, t[n], r), r);
              }, new this.FormDataConstructor());
            }, t.prototype.addMimeDataToFD = function (t, e, r) {
              f(r) ? Buffer.isBuffer(e) && r.append(t, e, {
                filename: "MimeMessage"
              }) : r.append(t, e, "MimeMessage");
            }, t.prototype.addFilesToFD = function (t, e, r) {
              var s = function (t, e, r) {
                var s = c(e) ? e : e.data,
                  o = function (t) {
                    if ("object" != typeof t || c(t)) return {};
                    var e = t.filename,
                      r = t.contentType,
                      s = t.knownLength;
                    return n(n(n({}, e ? {
                      filename: e
                    } : {
                      filename: "file"
                    }), r && {
                      contentType: r
                    }), s && {
                      knownLength: s
                    });
                  }(e);
                f(r) ? r.append(t, s, o) : r.append(t, s, o.filename);
              };
              Array.isArray(e) ? e.forEach(function (e) {
                s(t, e, r);
              }) : s(t, e, r);
            }, t.prototype.addCommonPropertyToFD = function (t, e, r) {
              Array.isArray(e) ? e.forEach(function (e) {
                r.append(t, e);
              }) : null != e && r.append(t, e);
            }, t.prototype.put = function (t, e, r) {
              return this.command("put", t, e, r);
            }, t.prototype.patch = function (t, e, r) {
              return this.command("patch", t, e, r);
            }, t.prototype.delete = function (t, e, r) {
              return this.command("delete", t, e, r);
            }, t;
          }();
          e.default = l;
        },
        277: (t, e) => {
          "use strict";

          Object.defineProperty(e, "__esModule", {
            value: !0
          });
          var r = function () {
            function t(t) {
              this.request = t;
            }
            return t.prototype.list = function (t) {
              return this.request.get("/v3/routes", t).then(function (t) {
                return t.body.items;
              });
            }, t.prototype.get = function (t) {
              return this.request.get("/v3/routes/" + t).then(function (t) {
                return t.body.route;
              });
            }, t.prototype.create = function (t) {
              return this.request.postWithFD("/v3/routes", t).then(function (t) {
                return t.body.route;
              });
            }, t.prototype.update = function (t, e) {
              return this.request.putWithFD("/v3/routes/" + t, e).then(function (t) {
                return t.body;
              });
            }, t.prototype.destroy = function (t) {
              return this.request.delete("/v3/routes/" + t).then(function (t) {
                return t.body;
              });
            }, t;
          }();
          e.default = r;
        },
        747: function (t, e, r) {
          "use strict";

          var n = this && this.__assign || function () {
              return n = Object.assign || function (t) {
                for (var e, r = 1, n = arguments.length; r < n; r++) for (var s in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
                return t;
              }, n.apply(this, arguments);
            },
            s = this && this.__spreadArray || function (t, e, r) {
              if (r || 2 === arguments.length) for (var n, s = 0, o = e.length; s < o; s++) !n && s in e || (n || (n = Array.prototype.slice.call(e, 0, s)), n[s] = e[s]);
              return t.concat(n || Array.prototype.slice.call(e));
            },
            o = this && this.__importDefault || function (t) {
              return t && t.__esModule ? t : {
                default: t
              };
            };
          Object.defineProperty(e, "__esModule", {
            value: !0
          });
          var i = o(r(78)),
            a = function (t) {
              this.start = new Date(t.start), this.end = new Date(t.end), this.resolution = t.resolution, this.stats = t.stats.map(function (t) {
                var e = n({}, t);
                return e.time = new Date(t.time), e;
              });
            },
            u = function () {
              function t(t) {
                this.request = t;
              }
              return t.prototype.prepareSearchParams = function (t) {
                var e = [];
                return "object" == typeof t && Object.keys(t).length && (e = Object.entries(t).reduce(function (t, e) {
                  var r = e[0],
                    n = e[1];
                  if (Array.isArray(n) && n.length) {
                    var o = n.map(function (t) {
                      return [r, t];
                    });
                    return s(s([], t, !0), o, !0);
                  }
                  return t.push([r, n]), t;
                }, [])), e;
              }, t.prototype._parseStats = function (t) {
                return new a(t.body);
              }, t.prototype.getDomain = function (t, e) {
                var r = this.prepareSearchParams(e);
                return this.request.get((0, i.default)("/v3", t, "stats/total"), r).then(this._parseStats);
              }, t.prototype.getAccount = function (t) {
                var e = this.prepareSearchParams(t);
                return this.request.get("/v3/stats/total", e).then(this._parseStats);
              }, t;
            }();
          e.default = u;
        },
        778: function (t, e, r) {
          "use strict";

          var n = this && this.__spreadArray || function (t, e, r) {
              if (r || 2 === arguments.length) for (var n, s = 0, o = e.length; s < o; s++) !n && s in e || (n || (n = Array.prototype.slice.call(e, 0, s)), n[s] = e[s]);
              return t.concat(n || Array.prototype.slice.call(e));
            },
            s = this && this.__importDefault || function (t) {
              return t && t.__esModule ? t : {
                default: t
              };
            };
          Object.defineProperty(e, "__esModule", {
            value: !0
          });
          var o = s(r(575)),
            i = s(r(78)),
            a = {
              headers: {
                "Content-Type": "application/json"
              }
            },
            u = function (t) {
              this.type = "bounces", this.address = t.address, this.code = +t.code, this.error = t.error, this.created_at = new Date(t.created_at);
            },
            h = function (t) {
              this.type = "complaints", this.address = t.address, this.created_at = new Date(t.created_at);
            },
            p = function (t) {
              this.type = "unsubscribes", this.address = t.address, this.tags = t.tags, this.created_at = new Date(t.created_at);
            },
            c = function (t) {
              this.type = "whitelists", this.value = t.value, this.reason = t.reason, this.createdAt = new Date(t.createdAt);
            },
            f = function () {
              function t(t) {
                this.request = t, this.models = {
                  bounces: u,
                  complaints: h,
                  unsubscribes: p,
                  whitelists: c
                };
              }
              return t.prototype._parsePage = function (t, e) {
                var r = o.default.parse(e, !0).query;
                return {
                  id: t,
                  page: r.page,
                  address: r.address,
                  url: e
                };
              }, t.prototype._parsePageLinks = function (t) {
                var e = this;
                return Object.entries(t.body.paging).reduce(function (t, r) {
                  var n = r[0],
                    s = r[1];
                  return t[n] = e._parsePage(n, s), t;
                }, {});
              }, t.prototype._parseList = function (t, e) {
                var r = {};
                return r.items = t.body.items.map(function (t) {
                  return new e(t);
                }), r.pages = this._parsePageLinks(t), r;
              }, t.prototype._parseItem = function (t, e) {
                return new e(t.body);
              }, t.prototype.createWhiteList = function (t, e) {
                return this.request.postWithFD((0, i.default)("v3", t, "whitelists"), e, a).then(function (t) {
                  return t.body;
                });
              }, t.prototype.list = function (t, e, r) {
                var n = this,
                  s = this.models[e];
                return this.request.get((0, i.default)("v3", t, e), r).then(function (t) {
                  return n._parseList(t, s);
                });
              }, t.prototype.get = function (t, e, r) {
                var n = this,
                  s = this.models[e];
                return this.request.get((0, i.default)("v3", t, e, encodeURIComponent(r))).then(function (t) {
                  return n._parseItem(t, s);
                });
              }, t.prototype.create = function (t, e, r) {
                var s;
                return "whitelists" === e ? this.createWhiteList(t, r) : (s = Array.isArray(r) ? n([], r, !0) : [r], this.request.post((0, i.default)("v3", t, e), JSON.stringify(s), a).then(function (t) {
                  return t.body;
                }));
              }, t.prototype.destroy = function (t, e, r) {
                return this.request.delete((0, i.default)("v3", t, e, encodeURIComponent(r))).then(function (t) {
                  return t.body;
                });
              }, t;
            }();
          e.default = f, t.exports = f;
        },
        721: (t, e) => {
          "use strict";

          Object.defineProperty(e, "__esModule", {
            value: !0
          });
          var r = function () {
            function t(t, e) {
              this.request = t, this.multipleValidation = e;
            }
            return t.prototype.get = function (t) {
              return this.request.get("/v4/address/validate", {
                address: t
              }).then(function (t) {
                return t;
              }).then(function (t) {
                return t.body;
              });
            }, t;
          }();
          e.default = r;
        },
        750: function (t, e, r) {
          "use strict";

          var n = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
          Object.defineProperty(e, "__esModule", {
            value: !0
          });
          var s = n(r(78)),
            o = function (t, e) {
              this.id = t, this.url = e;
            },
            i = function () {
              function t(t) {
                this.request = t;
              }
              return t.prototype._parseWebhookList = function (t) {
                return t.body.webhooks;
              }, t.prototype._parseWebhookWithID = function (t) {
                return function (e) {
                  var r,
                    n = null === (r = null == e ? void 0 : e.body) || void 0 === r ? void 0 : r.webhook,
                    s = null == n ? void 0 : n.url;
                  return s || (s = (null == n ? void 0 : n.urls) && n.urls.length ? n.urls[0] : void 0), new o(t, s);
                };
              }, t.prototype._parseWebhookTest = function (t) {
                return {
                  code: t.body.code,
                  message: t.body.message
                };
              }, t.prototype.list = function (t, e) {
                return this.request.get((0, s.default)("/v3/domains", t, "webhooks"), e).then(this._parseWebhookList);
              }, t.prototype.get = function (t, e) {
                return this.request.get((0, s.default)("/v3/domains", t, "webhooks", e)).then(this._parseWebhookWithID(e));
              }, t.prototype.create = function (t, e, r, n) {
                return void 0 === n && (n = !1), n ? this.request.putWithFD((0, s.default)("/v3/domains", t, "webhooks", e, "test"), {
                  url: r
                }).then(this._parseWebhookTest) : this.request.postWithFD((0, s.default)("/v3/domains", t, "webhooks"), {
                  id: e,
                  url: r
                }).then(this._parseWebhookWithID(e));
              }, t.prototype.update = function (t, e, r) {
                return this.request.putWithFD((0, s.default)("/v3/domains", t, "webhooks", e), {
                  url: r
                }).then(this._parseWebhookWithID(e));
              }, t.prototype.destroy = function (t, e) {
                return this.request.delete((0, s.default)("/v3/domains", t, "webhooks", e)).then(this._parseWebhookWithID(e));
              }, t;
            }();
          e.default = i;
        },
        501: function (t, e, r) {
          var n;
          t = r.nmd(t), function (s) {
            var o = e,
              i = (t && t.exports, "object" == typeof r.g && r.g);
            i.global !== i && i.window;
            var a = function (t) {
              this.message = t;
            };
            (a.prototype = new Error()).name = "InvalidCharacterError";
            var u = function (t) {
                throw new a(t);
              },
              h = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
              p = /[\t\n\f\r ]/g,
              c = {
                encode: function (t) {
                  t = String(t), /[^\0-\xFF]/.test(t) && u("The string to be encoded contains characters outside of the Latin1 range.");
                  for (var e, r, n, s, o = t.length % 3, i = "", a = -1, p = t.length - o; ++a < p;) e = t.charCodeAt(a) << 16, r = t.charCodeAt(++a) << 8, n = t.charCodeAt(++a), i += h.charAt((s = e + r + n) >> 18 & 63) + h.charAt(s >> 12 & 63) + h.charAt(s >> 6 & 63) + h.charAt(63 & s);
                  return 2 == o ? (e = t.charCodeAt(a) << 8, r = t.charCodeAt(++a), i += h.charAt((s = e + r) >> 10) + h.charAt(s >> 4 & 63) + h.charAt(s << 2 & 63) + "=") : 1 == o && (s = t.charCodeAt(a), i += h.charAt(s >> 2) + h.charAt(s << 4 & 63) + "=="), i;
                },
                decode: function (t) {
                  var e = (t = String(t).replace(p, "")).length;
                  e % 4 == 0 && (e = (t = t.replace(/==?$/, "")).length), (e % 4 == 1 || /[^+a-zA-Z0-9/]/.test(t)) && u("Invalid character: the string to be decoded is not correctly encoded.");
                  for (var r, n, s = 0, o = "", i = -1; ++i < e;) n = h.indexOf(t.charAt(i)), r = s % 4 ? 64 * r + n : n, s++ % 4 && (o += String.fromCharCode(255 & r >> (-2 * s & 6)));
                  return o;
                },
                version: "1.0.0"
              };
            void 0 === (n = function () {
              return c;
            }.call(e, r, e, t)) || (t.exports = n);
          }();
        },
        899: (t, e, r) => {
          "use strict";

          r.r(e), r.d(e, {
            default: () => R
          });
          const n = {},
            s = t => "undefined" != typeof self && self && t in self ? self : "undefined" != typeof window && window && t in window ? window : void 0 !== r.g && r.g && t in r.g ? r.g : "undefined" != typeof globalThis && globalThis ? globalThis : void 0,
            o = ["Headers", "Request", "Response", "ReadableStream", "fetch", "AbortController", "FormData"];
          for (const t of o) Object.defineProperty(n, t, {
            get() {
              const e = s(t),
                r = e && e[t];
              return "function" == typeof r ? r.bind(e) : r;
            }
          });
          const i = t => null !== t && "object" == typeof t,
            a = "function" == typeof n.AbortController,
            u = "function" == typeof n.ReadableStream,
            h = "function" == typeof n.FormData,
            p = (t, e) => {
              const r = new n.Headers(t || {}),
                s = e instanceof n.Headers,
                o = new n.Headers(e || {});
              for (const [t, e] of o) s && "undefined" === e || void 0 === e ? r.delete(t) : r.set(t, e);
              return r;
            },
            c = function () {
              let e = {},
                r = {};
              for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
                t[_key] = arguments[_key];
              }
              for (const n of t) {
                if (Array.isArray(n)) Array.isArray(e) || (e = []), e = [...e, ...n];else if (i(n)) {
                  for (let [t, r] of Object.entries(n)) i(r) && t in e && (r = c(e[t], r)), e = {
                    ...e,
                    [t]: r
                  };
                  i(n.headers) && (r = p(r, n.headers));
                }
                e.headers = r;
              }
              return e;
            },
            f = ["get", "post", "put", "patch", "head", "delete"],
            l = {
              json: "application/json",
              text: "text/*",
              formData: "multipart/form-data",
              arrayBuffer: "*/*",
              blob: "*/*"
            },
            d = [413, 429, 503],
            y = Symbol("stop");
          class HTTPError extends Error {
            constructor(t) {
              super(t.statusText || String(0 === t.status || t.status ? t.status : "Unknown response error")), this.name = "HTTPError", this.response = t;
            }
          }
          class TimeoutError extends Error {
            constructor(t) {
              super("Request timed out"), this.name = "TimeoutError", this.request = t;
            }
          }
          const m = t => new Promise(e => setTimeout(e, t)),
            v = t => f.includes(t) ? t.toUpperCase() : t,
            b = {
              limit: 2,
              methods: ["get", "put", "head", "delete", "options", "trace"],
              statusCodes: [408, 413, 429, 500, 502, 503, 504],
              afterStatusCodes: d
            },
            g = function () {
              let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              if ("number" == typeof t) return {
                ...b,
                limit: t
              };
              if (t.methods && !Array.isArray(t.methods)) throw new Error("retry.methods must be an array");
              if (t.statusCodes && !Array.isArray(t.statusCodes)) throw new Error("retry.statusCodes must be an array");
              return {
                ...b,
                ...t,
                afterStatusCodes: d
              };
            },
            _ = 2147483647;
          class Ky {
            constructor(t) {
              let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              if (this._retryCount = 0, this._input = t, this._options = {
                credentials: this._input.credentials || "same-origin",
                ...e,
                headers: p(this._input.headers, e.headers),
                hooks: c({
                  beforeRequest: [],
                  beforeRetry: [],
                  afterResponse: []
                }, e.hooks),
                method: v(e.method || this._input.method),
                prefixUrl: String(e.prefixUrl || ""),
                retry: g(e.retry),
                throwHttpErrors: !1 !== e.throwHttpErrors,
                timeout: void 0 === e.timeout ? 1e4 : e.timeout,
                fetch: e.fetch || n.fetch
              }, "string" != typeof this._input && !(this._input instanceof URL || this._input instanceof n.Request)) throw new TypeError("`input` must be a string, URL, or Request");
              if (this._options.prefixUrl && "string" == typeof this._input) {
                if (this._input.startsWith("/")) throw new Error("`input` must not begin with a slash when using `prefixUrl`");
                this._options.prefixUrl.endsWith("/") || (this._options.prefixUrl += "/"), this._input = this._options.prefixUrl + this._input;
              }
              if (a && (this.abortController = new n.AbortController(), this._options.signal && this._options.signal.addEventListener("abort", () => {
                this.abortController.abort();
              }), this._options.signal = this.abortController.signal), this.request = new n.Request(this._input, this._options), this._options.searchParams) {
                const t = "?" + new URLSearchParams(this._options.searchParams).toString(),
                  e = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, t);
                !(h && this._options.body instanceof n.FormData || this._options.body instanceof URLSearchParams) || this._options.headers && this._options.headers["content-type"] || this.request.headers.delete("content-type"), this.request = new n.Request(new n.Request(e, this.request), this._options);
              }
              void 0 !== this._options.json && (this._options.body = JSON.stringify(this._options.json), this.request.headers.set("content-type", "application/json"), this.request = new n.Request(this.request, {
                body: this._options.body
              }));
              const r = async () => {
                  if (this._options.timeout > _) throw new RangeError("The `timeout` option cannot be greater than 2147483647");
                  await m(1);
                  let t = await this._fetch();
                  for (const e of this._options.hooks.afterResponse) {
                    const r = await e(this.request, this._options, this._decorateResponse(t.clone()));
                    r instanceof n.Response && (t = r);
                  }
                  if (this._decorateResponse(t), !t.ok && this._options.throwHttpErrors) throw new HTTPError(t);
                  if (this._options.onDownloadProgress) {
                    if ("function" != typeof this._options.onDownloadProgress) throw new TypeError("The `onDownloadProgress` option must be a function");
                    if (!u) throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
                    return this._stream(t.clone(), this._options.onDownloadProgress);
                  }
                  return t;
                },
                s = this._options.retry.methods.includes(this.request.method.toLowerCase()) ? this._retry(r) : r();
              for (const [t, r] of Object.entries(l)) s[t] = async () => {
                this.request.headers.set("accept", this.request.headers.get("accept") || r);
                const n = (await s).clone();
                if ("json" === t) {
                  if (204 === n.status) return "";
                  if (e.parseJson) return e.parseJson(await n.text());
                }
                return n[t]();
              };
              return s;
            }
            _calculateRetryDelay(t) {
              if (this._retryCount++, this._retryCount < this._options.retry.limit && !(t instanceof TimeoutError)) {
                if (t instanceof HTTPError) {
                  if (!this._options.retry.statusCodes.includes(t.response.status)) return 0;
                  const e = t.response.headers.get("Retry-After");
                  if (e && this._options.retry.afterStatusCodes.includes(t.response.status)) {
                    let t = Number(e);
                    return Number.isNaN(t) ? t = Date.parse(e) - Date.now() : t *= 1e3, void 0 !== this._options.retry.maxRetryAfter && t > this._options.retry.maxRetryAfter ? 0 : t;
                  }
                  if (413 === t.response.status) return 0;
                }
                return .3 * 2 ** (this._retryCount - 1) * 1e3;
              }
              return 0;
            }
            _decorateResponse(t) {
              return this._options.parseJson && (t.json = async () => this._options.parseJson(await t.text())), t;
            }
            async _retry(t) {
              try {
                return await t();
              } catch (e) {
                const r = Math.min(this._calculateRetryDelay(e), _);
                if (0 !== r && this._retryCount > 0) {
                  await m(r);
                  for (const t of this._options.hooks.beforeRetry) {
                    if ((await t({
                      request: this.request,
                      options: this._options,
                      error: e,
                      retryCount: this._retryCount
                    })) === y) return;
                  }
                  return this._retry(t);
                }
                if (this._options.throwHttpErrors) throw e;
              }
            }
            async _fetch() {
              for (const t of this._options.hooks.beforeRequest) {
                const e = await t(this.request, this._options);
                if (e instanceof Request) {
                  this.request = e;
                  break;
                }
                if (e instanceof Response) return e;
              }
              return !1 === this._options.timeout ? this._options.fetch(this.request.clone()) : (t = this.request.clone(), e = this.abortController, r = this._options, new Promise((n, s) => {
                const o = setTimeout(() => {
                  e && e.abort(), s(new TimeoutError(t));
                }, r.timeout);
                r.fetch(t).then(n).catch(s).then(() => {
                  clearTimeout(o);
                });
              }));
              var t, e, r;
            }
            _stream(t, e) {
              const r = Number(t.headers.get("content-length")) || 0;
              let s = 0;
              return new n.Response(new n.ReadableStream({
                start(n) {
                  const o = t.body.getReader();
                  e && e({
                    percent: 0,
                    transferredBytes: 0,
                    totalBytes: r
                  }, new Uint8Array()), async function t() {
                    const {
                      done: i,
                      value: a
                    } = await o.read();
                    if (i) n.close();else {
                      if (e) {
                        s += a.byteLength;
                        e({
                          percent: 0 === r ? 0 : s / r,
                          transferredBytes: s,
                          totalBytes: r
                        }, a);
                      }
                      n.enqueue(a), t();
                    }
                  }();
                }
              }));
            }
          }
          const w = function () {
              for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                t[_key2] = arguments[_key2];
              }
              for (const e of t) if ((!i(e) || Array.isArray(e)) && void 0 !== e) throw new TypeError("The `options` argument must be an object");
              return c({}, ...t);
            },
            q = t => {
              const e = (e, r) => new Ky(e, w(t, r));
              for (const r of f) e[r] = (e, n) => new Ky(e, w(t, n, {
                method: r
              }));
              return e.HTTPError = HTTPError, e.TimeoutError = TimeoutError, e.create = t => q(w(t)), e.extend = e => q(w(t, e)), e.stop = y, e;
            },
            R = q();
        },
        971: function (t, e, r) {
          var n;
          t = r.nmd(t), function (s) {
            e && e.nodeType, t && t.nodeType;
            var o = "object" == typeof r.g && r.g;
            o.global !== o && o.window !== o && o.self;
            var i,
              a = 2147483647,
              u = 36,
              h = /^xn--/,
              p = /[^\x20-\x7E]/,
              c = /[\x2E\u3002\uFF0E\uFF61]/g,
              f = {
                overflow: "Overflow: input needs wider integers to process",
                "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                "invalid-input": "Invalid input"
              },
              l = Math.floor,
              d = String.fromCharCode;
            function y(t) {
              throw RangeError(f[t]);
            }
            function m(t, e) {
              for (var r = t.length, n = []; r--;) n[r] = e(t[r]);
              return n;
            }
            function v(t, e) {
              var r = t.split("@"),
                n = "";
              return r.length > 1 && (n = r[0] + "@", t = r[1]), n + m((t = t.replace(c, ".")).split("."), e).join(".");
            }
            function b(t) {
              for (var e, r, n = [], s = 0, o = t.length; s < o;) (e = t.charCodeAt(s++)) >= 55296 && e <= 56319 && s < o ? 56320 == (64512 & (r = t.charCodeAt(s++))) ? n.push(((1023 & e) << 10) + (1023 & r) + 65536) : (n.push(e), s--) : n.push(e);
              return n;
            }
            function g(t) {
              return m(t, function (t) {
                var e = "";
                return t > 65535 && (e += d((t -= 65536) >>> 10 & 1023 | 55296), t = 56320 | 1023 & t), e += d(t);
              }).join("");
            }
            function _(t, e) {
              return t + 22 + 75 * (t < 26) - ((0 != e) << 5);
            }
            function w(t, e, r) {
              var n = 0;
              for (t = r ? l(t / 700) : t >> 1, t += l(t / e); t > 455; n += u) t = l(t / 35);
              return l(n + 36 * t / (t + 38));
            }
            function q(t) {
              var e,
                r,
                n,
                s,
                o,
                i,
                h,
                p,
                c,
                f,
                d,
                m = [],
                v = t.length,
                b = 0,
                _ = 128,
                q = 72;
              for ((r = t.lastIndexOf("-")) < 0 && (r = 0), n = 0; n < r; ++n) t.charCodeAt(n) >= 128 && y("not-basic"), m.push(t.charCodeAt(n));
              for (s = r > 0 ? r + 1 : 0; s < v;) {
                for (o = b, i = 1, h = u; s >= v && y("invalid-input"), ((p = (d = t.charCodeAt(s++)) - 48 < 10 ? d - 22 : d - 65 < 26 ? d - 65 : d - 97 < 26 ? d - 97 : u) >= u || p > l((a - b) / i)) && y("overflow"), b += p * i, !(p < (c = h <= q ? 1 : h >= q + 26 ? 26 : h - q)); h += u) i > l(a / (f = u - c)) && y("overflow"), i *= f;
                q = w(b - o, e = m.length + 1, 0 == o), l(b / e) > a - _ && y("overflow"), _ += l(b / e), b %= e, m.splice(b++, 0, _);
              }
              return g(m);
            }
            function R(t) {
              var e,
                r,
                n,
                s,
                o,
                i,
                h,
                p,
                c,
                f,
                m,
                v,
                g,
                q,
                R,
                D = [];
              for (v = (t = b(t)).length, e = 128, r = 0, o = 72, i = 0; i < v; ++i) (m = t[i]) < 128 && D.push(d(m));
              for (n = s = D.length, s && D.push("-"); n < v;) {
                for (h = a, i = 0; i < v; ++i) (m = t[i]) >= e && m < h && (h = m);
                for (h - e > l((a - r) / (g = n + 1)) && y("overflow"), r += (h - e) * g, e = h, i = 0; i < v; ++i) if ((m = t[i]) < e && ++r > a && y("overflow"), m == e) {
                  for (p = r, c = u; !(p < (f = c <= o ? 1 : c >= o + 26 ? 26 : c - o)); c += u) R = p - f, q = u - f, D.push(d(_(f + R % q, 0))), p = l(R / q);
                  D.push(d(_(p, 0))), o = w(r, g, n == s), r = 0, ++n;
                }
                ++r, ++e;
              }
              return D.join("");
            }
            i = {
              version: "1.3.2",
              ucs2: {
                decode: b,
                encode: g
              },
              decode: q,
              encode: R,
              toASCII: function (t) {
                return v(t, function (t) {
                  return p.test(t) ? "xn--" + R(t) : t;
                });
              },
              toUnicode: function (t) {
                return v(t, function (t) {
                  return h.test(t) ? q(t.slice(4).toLowerCase()) : t;
                });
              }
            }, void 0 === (n = function () {
              return i;
            }.call(e, r, e, t)) || (t.exports = n);
          }();
        },
        587: t => {
          "use strict";

          function e(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
          }
          t.exports = function (t, r, n, s) {
            r = r || "&", n = n || "=";
            var o = {};
            if ("string" != typeof t || 0 === t.length) return o;
            var i = /\+/g;
            t = t.split(r);
            var a = 1e3;
            s && "number" == typeof s.maxKeys && (a = s.maxKeys);
            var u = t.length;
            a > 0 && u > a && (u = a);
            for (var h = 0; h < u; ++h) {
              var p,
                c,
                f,
                l,
                d = t[h].replace(i, "%20"),
                y = d.indexOf(n);
              y >= 0 ? (p = d.substr(0, y), c = d.substr(y + 1)) : (p = d, c = ""), f = decodeURIComponent(p), l = decodeURIComponent(c), e(o, f) ? Array.isArray(o[f]) ? o[f].push(l) : o[f] = [o[f], l] : o[f] = l;
            }
            return o;
          };
        },
        361: t => {
          "use strict";

          var e = function (t) {
            switch (typeof t) {
              case "string":
                return t;
              case "boolean":
                return t ? "true" : "false";
              case "number":
                return isFinite(t) ? t : "";
              default:
                return "";
            }
          };
          t.exports = function (t, r, n, s) {
            return r = r || "&", n = n || "=", null === t && (t = void 0), "object" == typeof t ? Object.keys(t).map(function (s) {
              var o = encodeURIComponent(e(s)) + n;
              return Array.isArray(t[s]) ? t[s].map(function (t) {
                return o + encodeURIComponent(e(t));
              }).join(r) : o + encodeURIComponent(e(t[s]));
            }).join(r) : s ? encodeURIComponent(e(s)) + n + encodeURIComponent(e(t)) : "";
          };
        },
        673: (t, e, r) => {
          "use strict";

          e.decode = e.parse = r(587), e.encode = e.stringify = r(361);
        },
        78: t => {
          function e(t) {
            return t.replace(/[\/]+/g, "/").replace(/\/\?/g, "?").replace(/\/\#/g, "#").replace(/\:\//g, "://");
          }
          t.exports = function () {
            var t = [].slice.call(arguments, 0).join("/");
            return e(t);
          };
        },
        575: (t, e, r) => {
          "use strict";

          var n = r(971),
            s = r(502);
          function o() {
            this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
          }
          e.parse = g, e.resolve = function (t, e) {
            return g(t, !1, !0).resolve(e);
          }, e.resolveObject = function (t, e) {
            return t ? g(t, !1, !0).resolveObject(e) : e;
          }, e.format = function (t) {
            s.isString(t) && (t = g(t));
            return t instanceof o ? t.format() : o.prototype.format.call(t);
          }, e.Url = o;
          var i = /^([a-z0-9.+-]+:)/i,
            a = /:[0-9]*$/,
            u = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
            h = ["{", "}", "|", "\\", "^", "`"].concat(["<", ">", '"', "`", " ", "\r", "\n", "\t"]),
            p = ["'"].concat(h),
            c = ["%", "/", "?", ";", "#"].concat(p),
            f = ["/", "?", "#"],
            l = /^[+a-z0-9A-Z_-]{0,63}$/,
            d = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
            y = {
              javascript: !0,
              "javascript:": !0
            },
            m = {
              javascript: !0,
              "javascript:": !0
            },
            v = {
              http: !0,
              https: !0,
              ftp: !0,
              gopher: !0,
              file: !0,
              "http:": !0,
              "https:": !0,
              "ftp:": !0,
              "gopher:": !0,
              "file:": !0
            },
            b = r(673);
          function g(t, e, r) {
            if (t && s.isObject(t) && t instanceof o) return t;
            var n = new o();
            return n.parse(t, e, r), n;
          }
          o.prototype.parse = function (t, e, r) {
            if (!s.isString(t)) throw new TypeError("Parameter 'url' must be a string, not " + typeof t);
            var o = t.indexOf("?"),
              a = -1 !== o && o < t.indexOf("#") ? "?" : "#",
              h = t.split(a);
            h[0] = h[0].replace(/\\/g, "/");
            var g = t = h.join(a);
            if (g = g.trim(), !r && 1 === t.split("#").length) {
              var _ = u.exec(g);
              if (_) return this.path = g, this.href = g, this.pathname = _[1], _[2] ? (this.search = _[2], this.query = e ? b.parse(this.search.substr(1)) : this.search.substr(1)) : e && (this.search = "", this.query = {}), this;
            }
            var w = i.exec(g);
            if (w) {
              var q = (w = w[0]).toLowerCase();
              this.protocol = q, g = g.substr(w.length);
            }
            if (r || w || g.match(/^\/\/[^@\/]+@[^@\/]+/)) {
              var R = "//" === g.substr(0, 2);
              !R || w && m[w] || (g = g.substr(2), this.slashes = !0);
            }
            if (!m[w] && (R || w && !v[w])) {
              for (var D, j, O = -1, A = 0; A < f.length; A++) {
                -1 !== (P = g.indexOf(f[A])) && (-1 === O || P < O) && (O = P);
              }
              -1 !== (j = -1 === O ? g.lastIndexOf("@") : g.lastIndexOf("@", O)) && (D = g.slice(0, j), g = g.slice(j + 1), this.auth = decodeURIComponent(D)), O = -1;
              for (A = 0; A < c.length; A++) {
                var P;
                -1 !== (P = g.indexOf(c[A])) && (-1 === O || P < O) && (O = P);
              }
              -1 === O && (O = g.length), this.host = g.slice(0, O), g = g.slice(O), this.parseHost(), this.hostname = this.hostname || "";
              var T = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
              if (!T) for (var C = this.hostname.split(/\./), k = (A = 0, C.length); A < k; A++) {
                var x = C[A];
                if (x && !x.match(l)) {
                  for (var M = "", F = 0, S = x.length; F < S; F++) x.charCodeAt(F) > 127 ? M += "x" : M += x[F];
                  if (!M.match(l)) {
                    var W = C.slice(0, A),
                      E = C.slice(A + 1),
                      I = x.match(d);
                    I && (W.push(I[1]), E.unshift(I[2])), E.length && (g = "/" + E.join(".") + g), this.hostname = W.join(".");
                    break;
                  }
                }
              }
              this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), T || (this.hostname = n.toASCII(this.hostname));
              var L = this.port ? ":" + this.port : "",
                U = this.hostname || "";
              this.host = U + L, this.href += this.host, T && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), "/" !== g[0] && (g = "/" + g));
            }
            if (!y[q]) for (A = 0, k = p.length; A < k; A++) {
              var N = p[A];
              if (-1 !== g.indexOf(N)) {
                var H = encodeURIComponent(N);
                H === N && (H = escape(N)), g = g.split(N).join(H);
              }
            }
            var V = g.indexOf("#");
            -1 !== V && (this.hash = g.substr(V), g = g.slice(0, V));
            var B = g.indexOf("?");
            if (-1 !== B ? (this.search = g.substr(B), this.query = g.substr(B + 1), e && (this.query = b.parse(this.query)), g = g.slice(0, B)) : e && (this.search = "", this.query = {}), g && (this.pathname = g), v[q] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
              L = this.pathname || "";
              var J = this.search || "";
              this.path = L + J;
            }
            return this.href = this.format(), this;
          }, o.prototype.format = function () {
            var t = this.auth || "";
            t && (t = (t = encodeURIComponent(t)).replace(/%3A/i, ":"), t += "@");
            var e = this.protocol || "",
              r = this.pathname || "",
              n = this.hash || "",
              o = !1,
              i = "";
            this.host ? o = t + this.host : this.hostname && (o = t + (-1 === this.hostname.indexOf(":") ? this.hostname : "[" + this.hostname + "]"), this.port && (o += ":" + this.port)), this.query && s.isObject(this.query) && Object.keys(this.query).length && (i = b.stringify(this.query));
            var a = this.search || i && "?" + i || "";
            return e && ":" !== e.substr(-1) && (e += ":"), this.slashes || (!e || v[e]) && !1 !== o ? (o = "//" + (o || ""), r && "/" !== r.charAt(0) && (r = "/" + r)) : o || (o = ""), n && "#" !== n.charAt(0) && (n = "#" + n), a && "?" !== a.charAt(0) && (a = "?" + a), e + o + (r = r.replace(/[?#]/g, function (t) {
              return encodeURIComponent(t);
            })) + (a = a.replace("#", "%23")) + n;
          }, o.prototype.resolve = function (t) {
            return this.resolveObject(g(t, !1, !0)).format();
          }, o.prototype.resolveObject = function (t) {
            if (s.isString(t)) {
              var e = new o();
              e.parse(t, !1, !0), t = e;
            }
            for (var r = new o(), n = Object.keys(this), i = 0; i < n.length; i++) {
              var a = n[i];
              r[a] = this[a];
            }
            if (r.hash = t.hash, "" === t.href) return r.href = r.format(), r;
            if (t.slashes && !t.protocol) {
              for (var u = Object.keys(t), h = 0; h < u.length; h++) {
                var p = u[h];
                "protocol" !== p && (r[p] = t[p]);
              }
              return v[r.protocol] && r.hostname && !r.pathname && (r.path = r.pathname = "/"), r.href = r.format(), r;
            }
            if (t.protocol && t.protocol !== r.protocol) {
              if (!v[t.protocol]) {
                for (var c = Object.keys(t), f = 0; f < c.length; f++) {
                  var l = c[f];
                  r[l] = t[l];
                }
                return r.href = r.format(), r;
              }
              if (r.protocol = t.protocol, t.host || m[t.protocol]) r.pathname = t.pathname;else {
                for (var d = (t.pathname || "").split("/"); d.length && !(t.host = d.shift()););
                t.host || (t.host = ""), t.hostname || (t.hostname = ""), "" !== d[0] && d.unshift(""), d.length < 2 && d.unshift(""), r.pathname = d.join("/");
              }
              if (r.search = t.search, r.query = t.query, r.host = t.host || "", r.auth = t.auth, r.hostname = t.hostname || t.host, r.port = t.port, r.pathname || r.search) {
                var y = r.pathname || "",
                  b = r.search || "";
                r.path = y + b;
              }
              return r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
            }
            var g = r.pathname && "/" === r.pathname.charAt(0),
              _ = t.host || t.pathname && "/" === t.pathname.charAt(0),
              w = _ || g || r.host && t.pathname,
              q = w,
              R = r.pathname && r.pathname.split("/") || [],
              D = (d = t.pathname && t.pathname.split("/") || [], r.protocol && !v[r.protocol]);
            if (D && (r.hostname = "", r.port = null, r.host && ("" === R[0] ? R[0] = r.host : R.unshift(r.host)), r.host = "", t.protocol && (t.hostname = null, t.port = null, t.host && ("" === d[0] ? d[0] = t.host : d.unshift(t.host)), t.host = null), w = w && ("" === d[0] || "" === R[0])), _) r.host = t.host || "" === t.host ? t.host : r.host, r.hostname = t.hostname || "" === t.hostname ? t.hostname : r.hostname, r.search = t.search, r.query = t.query, R = d;else if (d.length) R || (R = []), R.pop(), R = R.concat(d), r.search = t.search, r.query = t.query;else if (!s.isNullOrUndefined(t.search)) {
              if (D) r.hostname = r.host = R.shift(), (T = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = T.shift(), r.host = r.hostname = T.shift());
              return r.search = t.search, r.query = t.query, s.isNull(r.pathname) && s.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.href = r.format(), r;
            }
            if (!R.length) return r.pathname = null, r.search ? r.path = "/" + r.search : r.path = null, r.href = r.format(), r;
            for (var j = R.slice(-1)[0], O = (r.host || t.host || R.length > 1) && ("." === j || ".." === j) || "" === j, A = 0, P = R.length; P >= 0; P--) "." === (j = R[P]) ? R.splice(P, 1) : ".." === j ? (R.splice(P, 1), A++) : A && (R.splice(P, 1), A--);
            if (!w && !q) for (; A--; A) R.unshift("..");
            !w || "" === R[0] || R[0] && "/" === R[0].charAt(0) || R.unshift(""), O && "/" !== R.join("/").substr(-1) && R.push("");
            var T,
              C = "" === R[0] || R[0] && "/" === R[0].charAt(0);
            D && (r.hostname = r.host = C ? "" : R.length ? R.shift() : "", (T = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = T.shift(), r.host = r.hostname = T.shift()));
            return (w = w || r.host && R.length) && !C && R.unshift(""), R.length ? r.pathname = R.join("/") : (r.pathname = null, r.path = null), s.isNull(r.pathname) && s.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.auth = t.auth || r.auth, r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
          }, o.prototype.parseHost = function () {
            var t = this.host,
              e = a.exec(t);
            e && (":" !== (e = e[0]) && (this.port = e.substr(1)), t = t.substr(0, t.length - e.length)), t && (this.hostname = t);
          };
        },
        502: t => {
          "use strict";

          t.exports = {
            isString: function (t) {
              return "string" == typeof t;
            },
            isObject: function (t) {
              return "object" == typeof t && null !== t;
            },
            isNull: function (t) {
              return null === t;
            },
            isNullOrUndefined: function (t) {
              return null == t;
            }
          };
        }
      },
      e = {};
    function r(n) {
      var s = e[n];
      if (void 0 !== s) return s.exports;
      var o = e[n] = {
        id: n,
        loaded: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, r), o.loaded = !0, o.exports;
    }
    return r.d = (t, e) => {
      for (var n in e) r.o(e, n) && !r.o(t, n) && Object.defineProperty(t, n, {
        enumerable: !0,
        get: e[n]
      });
    }, r.g = function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (t) {
        if ("object" == typeof window) return window;
      }
    }(), r.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), r.r = t => {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.nmd = t => (t.paths = [], t.children || (t.children = []), t), r(175);
  })();
});